import * as constants from '../constants';
import config from './config';

const authorization = constants.AUTHORIZATION;

const createConfig = (access_token) =>
  localStorage.setItem(authorization, config.authorizationType + access_token);

const getConfig = () => {
  let data = localStorage.getItem(authorization);
  if (data !== '' && data !== null && data !== undefined) return data;
  else return false;
};

const deleteConfigs = () => localStorage.removeItem(authorization);

//////////////////////////////////////////////////////////////////

const createMapConfig = (mapType) => localStorage.setItem(constants.MAP_CONFIG, mapType);

const getMapConfig = () => {
  let data = localStorage.getItem(constants.MAP_CONFIG);
  if (data !== '' && data !== null && data !== undefined) return data;
  else return constants.MAP_TYPE_MAPGL;
};
//////////////////////////////////////////////////////////////////

const setIpAddress = (ip) => localStorage.setItem(constants.MY_IP, ip);

const getIpAddress = () => {
  let ip = localStorage.getItem(constants.MY_IP);
  if (ip !== '' && ip !== null && ip !== undefined) return ip;
  else return '0.0.0.0';
};

//////////////////////////////////////////////////////////////////

export {
  getConfig,
  getMapConfig,
  createConfig,
  deleteConfigs,
  createMapConfig,
  setIpAddress,
  getIpAddress,
};
